import React from "react";
import { Routes, Route } from "react-router-dom";  // ← Remove BrowserRouter from here

import Layout from "../layouts/layout";
import Home from "../pages/Home";
import Contact from "../pages/Contact";
import Projects from "../pages/Projets";
import CV from "../pages/CV";

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/projet" element={<Projects />} />
        <Route path="/CV" element={<CV />} />

      </Route>
    </Routes>
  );
};

export default AppRoutes;